var checkboxStyles = function (theme, state) {
    var checkbox = theme.olist.components.checkbox;
    return {
        backgroundColor: checkbox['background-color'][state],
        borderColor: checkbox['border-color'][state],
        boxShadow: checkbox['box-shadow'][state],
    };
};

export { checkboxStyles };
